<template>
  <div class="main" :class="{ main__zh: $i18n.locale === 'zh' }">
    <img
      v-for="i in 6"
      :key="i"
      :class="`background--triangle${i}`"
      :src="require(`@/assets/home/desktop/background${i}.png`)"
    />
    <video
      class="background"
      src="https://cdn.alsgp0.fds.api.mi-img.com/mint-mediation-official-website/collection.mp4"
      poster="@/assets/home/desktop/provides.png"
      muted
      autoplay
      loop
    />
    <div class="header" :class="headerFixed ? 'isFixed' : ''">
      <div class="header-left">
        <img
          v-if="headerFixed"
          src="@/assets/home/common/mi logo original.png"
        />
        <img v-else src="@/assets/home/common/mi logo.png" />
        <span>MINT</span>
        <div class="dropdown">
          <span>{{ $t('message.header.access') }}</span>
          <div class="dropdown-content">
            <a
              v-track="{
                eventName: ENUM_EVENT_NAME.ANDROID_DOC
              }"
              :href="
                'https://ads.mi.com/mediation/mint/docs/android/' + docLocale
              "
              target="_blank"
            >
              Android
            </a>
            <a
              v-track="{
                eventName: ENUM_EVENT_NAME.UNITY_DOC
              }"
              :href="
                'https://ads.mi.com/mediation/mint/docs/unity/' + docLocale
              "
              target="_blank"
            >
              Unity
            </a>
            <a
              v-track="{
                eventName: ENUM_EVENT_NAME.IOS_DOC
              }"
              :href="
                'https://ads.mi.com/mediation/mint/docs/ios/' + docLocale
              "
              target="_blank"
            >
              IOS
            </a>
          </div>
        </div>
        <div class="dropdown">
          <a
            v-track="{
              eventName: ENUM_EVENT_NAME.OPERATION_GUIDE
            }"
            :href="
              'https://ads.mi.com/mediation/mint/docs/operation/' + docLocale
            "
            target="_blank"
          >
            <span>{{ $t('message.header.operation') }}</span>
          </a>
        </div>
      </div>
      <div class="header-right">
        <span
          :class="{ 'header-locale': $i18n.locale === 'zh' }"
          @click="changeLocale('zh')"
          >中</span
        >
        <div></div>
        <span
          :class="{ 'header-locale': $i18n.locale === 'en' }"
          @click="changeLocale('en')"
          >EN</span
        >
        <button
          v-track="{
            eventName: ENUM_EVENT_NAME.EXPLORE_NOW
          }"
          onclick="location.href='https://dev.mint.mi.com/overview/dashboard'"
        >
          {{ $t('message.header.explore') }}
        </button>
      </div>
    </div>
    <div class="container">
      <section class="provides">
        <h1>{{ $t('message.provides.h1') }}</h1>
        <p>{{ $t('message.provides.p') }}</p>
        <div>
          <button
             v-track="{
              eventName: ENUM_EVENT_NAME.GET_STARTED
            }"
            class="provides-started"
            onclick="location.href='https://dev.mint.mi.com/overview/dashboard'"
          >
            {{ $t('message.provides.started') }}
          </button>
          <button
            v-track="{
              eventName: ENUM_EVENT_NAME.GET_SDK
            }"
            class="provides-sdk"
            onclick="location.href='https://ads.mi.com/mediation/mint/docs/android/'"
          >
            {{ $t('message.provides.sdk') }}
          </button>
        </div>
      </section>
      <section class="why">
        <h1>{{ $t('message.why.h1') }}</h1>
        <div class="why-reasons">
          <div class="why-reasons1">
            <img src="@/assets/home/common/why1.png" />
            <p v-html="$t('message.why.reasons[0]')"></p>
          </div>
          <div class="why-reasons2">
            <img src="@/assets/home/common/why2.png" />
            <p v-html="$t('message.why.reasons[1]')"></p>
          </div>
          <div class="why-reasons3">
            <img src="@/assets/home/common/why3.png" />
            <p v-html="$t('message.why.reasons[2]')"></p>
          </div>
          <div class="why-reasons4">
            <img src="@/assets/home/common/why4.png" />
            <p v-html="$t('message.why.reasons[3]')"></p>
          </div>
          <div class="why-reasons5">
            <img src="@/assets/home/common/why5.png" />
            <p v-html="$t('message.why.reasons[4]')"></p>
          </div>
          <div class="why-reasons6">
            <img src="@/assets/home/common/why6.png" />
            <p v-html="$t('message.why.reasons[5]')"></p>
          </div>
        </div>
      </section>
      <section class="diversified">
        <h1>{{ $t('message.diversified.h1') }}</h1>
        <div class="slider-container">
          <img
            class="slider-background"
            src="@/assets/home/common/diversified background.png"
          />
          <ul class="slider-dots">
            <li
              v-for="(item, i) of sliderArray"
              :class="{ active: i === index }"
              :key="i"
              @click="onSliderClick(i)"
            >
              {{ $t(`message.diversified.sliderArray[${i}]`) }}
            </li>
          </ul>
          <ul class="slider-images">
            <li
              v-for="(item, i) of sliderArray"
              :class="{ active: i === index }"
              :key="i"
              @mouseleave="autoStart"
              @mouseenter="autoStop"
            >
              <img :src="require(`@/assets/home/common/${item}.png`)" />
            </li>
          </ul>
        </div>
      </section>
      <section class="aggregated">
        <div>
          <h1>{{ $t('message.aggregated.h1') }}</h1>
        </div>
      </section>
      <section class="intelligent">
        <div class="intelligent-container">
          <img src="@/assets/home/common/intelligent cms.png" />
          <div>
            <h1>{{ $t('message.intelligent.h1') }}</h1>
            <p>{{ $t('message.intelligent.p') }}</p>
          </div>
        </div>
      </section>
      <section class="managed">
        <h1>{{ $t('message.managed.h1') }}</h1>
        <p>{{ $t('message.managed.p') }}</p>
        <div class="managed-reasons">
          <div class="managed-reasons1">
            <img src="@/assets/home/desktop/managed1.png" />
            <span :class="{ 'managed-reason__zh': $i18n.locale === 'zh' }">{{
              $t('message.managed.reasons[0]')
            }}</span>
          </div>
          <div class="managed-reasons2">
            <img src="@/assets/home/desktop/managed2.png" />
            <span :class="{ 'managed-reason__zh': $i18n.locale === 'zh' }">{{
              $t('message.managed.reasons[1]')
            }}</span>
          </div>
          <div class="managed-reasons3">
            <img src="@/assets/home/desktop/managed3.png" />
            <span :class="{ 'managed-reason__zh': $i18n.locale === 'zh' }">{{
              $t('message.managed.reasons[2]')
            }}</span>
          </div>
        </div>
      </section>
      <section class="excellent">
        <h1>{{ $t('message.excellent.h1') }}</h1>
        <img src="@/assets/home/desktop/excellent.png" />
      </section>
      <section class="contact">
        <button
          v-track="{
            eventName: ENUM_EVENT_NAME.CONTACT_US
          }"
          onclick="location.href='mailto:advertise@xiaomi.com'"
        >
          {{ $t('message.contact.button') }}
        </button>
      </section>
    </div>
    <div class="footer">
      <div class="footer-container">
        <img src="@/assets/home/common/xiaomi logo.png" />
        <div class="footer-line"></div>
        <div class="info">
          <span>{{ $t('message.footer.about') }}</span>
          <a href="https://ads.mi.com/">{{
            $t('message.footer.advertising')
          }}</a>
          <a href="https://global.e.mi.com/">{{
            $t('message.footer.miads')
          }}</a>
          <a href="">{{ $t('message.footer.blog') }}</a>
        </div>
        <div class="info">
          <span>{{ $t('message.footer.contact') }}</span>
          <a href="mailto:advertise@xiaomi.com">advertise@xiaomi.com</a>
          <a href="https://global.developer.mi.com"
            >https://global.developer.mi.com</a
          >
          <a href="https://e.mi.com">https://e.mi.com</a>
          <a href="https://www.linkedin.com/company/mi-ads/"
            ><img src="@/assets/home/common/linkedin logo.png"
          /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ENUM_EVENT_NAME } from '@/consts'

export default {
  name: 'index',

  data() {
    return {
      sliderArray: [
        'native',
        'rewarded video',
        'interstitial',
        'splash',
        'banner',
      ],
      index: 0,
      timer: null,
      headerFixed: false,
      ENUM_EVENT_NAME,
    }
  },

  mounted() {
    // var videoElement = document.getElementsByTagName('video')[0]
    // videoElement.oncanplaythrough = () => {
    //   console.log('canplaythrough')
    //   videoElement.play()
    // }

    window.addEventListener('scroll', this.handleScroll, true)
    this.autoStart()
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, true)
    this.autoStop()
  },

  computed: {
    docLocale() {
      return this.$i18n.locale === 'en' ? this.$i18n.locale + '/' : ''
    },
  },

  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale
    },
    autoStart() {
      if (this.timer) {
        return
      }
      this.timer = setInterval(() => {
        this.index = (this.index + 1) % this.sliderArray.length
      }, 3000)
    },
    autoStop() {
      clearInterval(this.timer)
      this.timer = null
    },
    onSliderClick(index) {
      this.index = index
      this.autoStop()
      this.autoStart()
    },
    handleScroll() {
      // 得到页面滚动的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      // 当滚动超过1080px时，实现吸顶效果。
      if (scrollTop > 1080) {
        this.headerFixed = true
      } else {
        this.headerFixed = false
      }
    },
  },
}
</script>

<style scoped lang="scss" src="./index.scss"></style>
